import { cvv } from 'card-validator';
import { type Verification } from 'card-validator/dist/types';

const cardCvvValidator = (cardCvv: string): Verification['isValid'] => {
  const { isValid } = cvv(cardCvv, [3, 4]);
  return isValid;
};

export default cardCvvValidator;
